export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/bass.0ae15b2.svg";